export default __webpack_public_path__ + "static/premio2AR-b19177dc300be2100b8cc0f87d293173.png";